import { Cookies } from 'react-cookie';
import { Navigate } from 'react-router-dom';
import { PATHS } from '../../constants';

export default function AuthRequired({ children }) {
  const cookies = new Cookies();
  const token = cookies.get('token');
  return token ? children : <Navigate to={PATHS.login_please} replace />;
}
